// MD2 PRO
import MDBox from 'components/MDBox';

// Components
import Chat from 'components/General/Chat';
import ProductionAndProjectRelation from 'layouts/production/Components/ProductionAndProjectRelation';
import ProductionProgress from 'layouts/production/Components/AaroComponents/ProductionProgress';
function SidebarLeft({ production, relatedID, aaroQueries, setValue }) {
    // Ensure production object exists to prevent errors
    if (!production) {
        return null;
    }

    return (
        <>
            <MDBox mb={2}>
                <ProductionProgress aaroQueries={aaroQueries} />
            </MDBox>
            <MDBox mb={2}>
                <Chat relatedID={relatedID} source="productions" />
            </MDBox>

            <MDBox mb={2}>
                <ProductionAndProjectRelation production={production} setValue={setValue} showRelateButton={false} />
            </MDBox>
        </>
    );
}

export default SidebarLeft;
